import { createContext, useContext } from "react";

export interface EventOccurrenceContextValue {
  eventOccurrenceId: string;
}

export const EventOccurrenceContext = createContext<
  EventOccurrenceContextValue | undefined
>(undefined);

export const { Provider: EventOccurrenceContextProvider } =
  EventOccurrenceContext;

export const useEventOccurrenceContext = (): EventOccurrenceContextValue => {
  const value = useContext(EventOccurrenceContext);

  if (!value) {
    throw new Error(
      "Make sure you are using useEventOccurrenceContext inside`EventOccurrenceContextProvider` provider"
    );
  }

  return value;
};
